import React from 'react'

import { TextGradient, Image2Gradient } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import { buildLocalizedPath } from 'Utils/getLocalizedUrl'

const ICONS = {
  'text-to-3d': TextGradient,
  'image-to-3d': Image2Gradient,
}

function buildAiHref(mode, query) {
  const params = new URLSearchParams({ mode })
  const prompt = query?.trim()

  if (mode === 'text-to-3d' && prompt) {
    params.set('prompt', prompt)
  }

  return buildLocalizedPath(`/ai?${params.toString()}`)
}

function AiCard({ mode, title, description, query = '' }) {
  const Glyph = ICONS[mode]

  return (
    <a
      className="home-search-dropdown__ai-card"
      href={buildAiHref(mode, query)}
      data-track="home-search-ai-card"
      data-content-type={mode}
    >
      <span className="home-search-dropdown__ai-card-icon">
        {Glyph && <Glyph className="home-search-dropdown__ai-card-glyph" aria-hidden="true" />}
      </span>
      <span className="home-search-dropdown__ai-card-text">
        <span className="home-search-dropdown__ai-card-title cgt-body-md-semibold">{title}</span>
        <span className="home-search-dropdown__ai-card-description cgt-caption">{description}</span>
      </span>
    </a>
  )
}

AiCard.propTypes = {
  mode: string.isRequired,
  title: string.isRequired,
  description: string.isRequired,
  query: string,
}

export default AiCard
